export default function CheckedItem(props) {
    return (<div style="display: flex; align-items: center; gap: 8px;">
            <input class="checked-item" type="checkbox" checked onClick={(e) => e.preventDefault()}/>
            <label style="font-size: var(--emsurge-marketplace-medium-font-size);">
                {props.value}
            </label>
        </div>);
}
